// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../opt/devenv/crmeb/mer_plat_admin/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.svg-icon[data-v-c8a70580] {\n  width: 1em;\n  height: 1em;\n  vertical-align: -0.15em;\n  fill: currentColor;\n  overflow: hidden;\n}\n.svg-external-icon[data-v-c8a70580] {\n  background-color: currentColor;\n  -webkit-mask-size: cover !important;\n          mask-size: cover !important;\n  display: inline-block;\n}\n", ""]);
// Exports
module.exports = exports;
